import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/images/recent_orders.png'
import _imports_1 from '@/images/language.svg'
import _imports_2 from '@/images/icon_white_down.png'


const _hoisted_1 = { class: "bg-permaBlack5 sm:max-w-440px w-full rounded-xl mb:pt-6 pt-4 pb-4" }
const _hoisted_2 = { class: "flex cursor-pointer items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-5 h-5 mr-2",
  alt: "recentOrders"
}, null, -1)
const _hoisted_4 = { class: "text-permaWhite1 hover:text-white transition-colors" }
const _hoisted_5 = { class: "text-14px px-6 mb:pb-6 pb-4 mt-0" }
const _hoisted_6 = { class: "flex flex-col cursor-pointer overflow-hidden md:mt-0 mt-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-5 h-5 mr-2",
  al: "language"
}, null, -1)
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["href"]
const _hoisted_10 = ["src", "alt"]

import { useI18n } from 'vue-i18n'
import { computed, ref } from 'vue'
import MoreFooter from './MoreFooter.vue'
import { savedI18nStorageKey } from '@/constants'
import SimpleWrapper from '../SimpleWrapper.vue'

interface Emits {
  (e: 'close'): void
  (e: 'recentMdalVisible'):void
}
interface Props {
  visible: boolean
  connected: boolean
}

export default /*#__PURE__*/_defineComponent({
  props: {
    visible: null,
    connected: null
  },
  emits: ["close", "recentMdalVisible"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'close'): void
  (e: 'recentMdalVisible'):void
}), expose: any, slots: any, attrs: any }) {



const { t, locale } = useI18n()
const localeVisible = ref(false)
const changeLocale = (lang: string) => {
  window.localStorage.setItem(savedI18nStorageKey, lang)
  locale.value = lang
  localeVisible.value = false
  emits('close')
}
const isHover = ref(false)
const whitepaperLink = computed(() => {
  return locale.value === 'zh-TW' ? 'https://mirror.xyz/permaswap.eth/kdg0iXx1jB-vXYEc_WEAeTNX_sGjv8BXksHxcFdoKjo' : 'https://mirror.xyz/permaswap.eth/ustZcDgavlm4xmYI26thEAj8W2cXlZpRkG5Jqz0iS14'
})
const languages = [
  {
    value: 'zh-TW',
    label: '繁体中文'
  },
  {
    value: 'en',
    label: 'English'
  }
]
const moreInfoList = computed(() => {
  return [
    {
      img: 'book.svg',
      name: t('whitepaper'),
      href: whitepaperLink.value
    },
    {
      img: 'audit_report.svg',
      name: t('audit_report'),
      href: 'https://arseed.web3infra.dev/RGcaT5ZztAGF0k62CHPILNCT5_XMuJpeoDMb7nRwkqo'
    },
    {
      img: 'wiki.svg',
      name: 'Wiki',
      href: 'https://www.notion.so/PermaSwap-WIKI-EN-485cd6623f954902b61775e4f1a86717'
    }
    // {
    //   img: 'permaDao_logo.svg',
    //   name: 'PermaDAO',
    //   href: 'https://permadao.com/'
    // }
  ]
})
const ContactInformation = [
  // {
  //   href: 'https://github.com/permaswap/perma-dapp',
  //   img: 'github.png'
  // },
  {
    href: 'https://twitter.com/permaswap',
    img: 'twitter.png'
  },
  {
    href: 'https://medium.com/permaswap',
    img: 'medium.png'
  },
  {
    href: 'https://discord.gg/WM5MQZGVPF',
    img: 'discord.png'
  },
  {
    href: 'https://t.me/FinanceEver',
    img: 'telegram.png'
  }
]
const OtherInformation = [
  {
    href: 'https://everpay.io/',
    img: 'everPay.png'
  },
  {
    href: 'https://ever.vision/#/',
    img: 'everFinance.png'
  }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SimpleWrapper, { class: "md:absolute md:right-0 md:px-0 md:left-auto md:top-50px top-20 fixed flex sm:justify-end justify-center right-0 px-4 w-full z-20" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default"),
        _createElementVNode("div", {
          class: "md:hidden block py-4 px-6 border-t border-b border-permaWhite5 border-opacity-50 rencentOrdersModal box-border",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {emits('recentMdalVisible');emits('close')})
        }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('recent_orders')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex items-center transition-opacity", localeVisible.value ? 'opacity-100' : 'opacity-85 hover:opacity-100']),
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (localeVisible.value = !localeVisible.value), ["stop"]))
            }, [
              _hoisted_7,
              _createElementVNode("span", null, _toDisplayString(_unref(locale) === 'zh-TW' ? '繁体中文' : 'English'), 1),
              _createElementVNode("img", {
                src: _imports_2,
                class: _normalizeClass(["w-4 h-4 ml-1 transform transition-transform", localeVisible.value ? 'rotate-180' : 'rotate-0']),
                alt: "WhiteDownIcon"
              }, null, 2)
            ], 2),
            _createElementVNode("div", {
              class: "pl-7 transition-all overflow-hidden duration-300",
              style: _normalizeStyle(`height:${localeVisible.value ? '60px' : '0px'}`)
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(languages, (lang, index) => {
                return _createElementVNode("div", {
                  key: index,
                  class: _normalizeClass(["mt-2 transition-colors hover:text-permaGreen11 active:text-permaGreen9", _unref(locale) === lang.value && !isHover.value ? 'text-permaGreen4' : 'text-white']),
                  onMousemove: _cache[2] || (_cache[2] = ($event: any) => (isHover.value = true)),
                  onMouseout: _cache[3] || (_cache[3] = ($event: any) => (isHover.value = false)),
                  onClick: _withModifiers(($event: any) => (changeLocale(lang.value)), ["stop"])
                }, _toDisplayString(lang.label), 43, _hoisted_8)
              }), 64))
            ], 4)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(moreInfoList), (item, index) => {
            return (_openBlock(), _createElementBlock("a", {
              key: index,
              class: "flex items-center cursor-pointer mt-4 opacity-85 hover:opacity-100 transition-opacity",
              href: item.href,
              target: "_blank"
            }, [
              _createElementVNode("img", {
                src: require(`@/images/${item.img}`),
                class: "w-5 h-5 mr-2",
                alt: item.name
              }, null, 8, _hoisted_10),
              _createElementVNode("span", null, _toDisplayString(item.name), 1)
            ], 8, _hoisted_9))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["flex justify-between items-center px-6 border-t pt-4", __props.connected ? 'border-permaWhite5 border-opacity-50' : 'border-white border-opacity-10'])
        }, [
          _createVNode(MoreFooter, { "src-list": ContactInformation }),
          _createVNode(MoreFooter, { "src-list": OtherInformation })
        ], 2)
      ], 512), [
        [_vShow, __props.visible]
      ])
    ]),
    _: 3
  }))
}
}

})